var _path, _path2, _path3, _rect, _rect2, _rect3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityMeeting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 38,
    viewBox: "0 0 30 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    title: "meeting",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H29V25H1V1Z",
    fill: "white",
    stroke: "#285FCB",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4C7.07458 4 6.17779 4.32088 5.46243 4.90796C4.74707 5.49504 4.2574 6.312 4.07686 7.21964C3.89632 8.12728 4.03607 9.06944 4.47231 9.88559C4.90856 10.7017 5.61429 11.3414 6.46927 11.6955C7.32424 12.0497 8.27557 12.0964 9.16114 11.8278C10.0467 11.5591 10.8117 10.9917 11.3259 10.2223C11.84 9.45282 12.0714 8.5289 11.9807 7.60793C11.89 6.68697 11.4828 5.82595 10.8284 5.17157L8 8L8 4Z",
    fill: "#EEF1F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C7.20887 14 6.43552 14.2346 5.77772 14.6741C5.11992 15.1136 4.60723 15.7384 4.30448 16.4693C4.00173 17.2002 3.92252 18.0044 4.07686 18.7804C4.2312 19.5563 4.61216 20.269 5.17157 20.8284C5.73098 21.3878 6.44371 21.7688 7.21964 21.9231C7.99556 22.0775 8.79983 21.9983 9.53073 21.6955C10.2616 21.3928 10.8864 20.8801 11.3259 20.2223C11.7654 19.5645 12 18.7911 12 18L8 18L8 14Z",
    fill: "#EEF1F4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 11,
    width: 11,
    height: 3,
    fill: "#EEF1F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 17,
    width: 7,
    height: 3,
    fill: "#EEF1F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 5,
    width: 11,
    height: 3,
    fill: "#EEF1F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 37L15 33L11 37",
    stroke: "#285FCB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 33L15 25",
    stroke: "#285FCB",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityMeeting);
export default __webpack_public_path__ + "static/media/activityMeeting.e8d3bbb2.svg";
export { ForwardRef as ReactComponent };